(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("declarativeFactory", [], factory);
	else if(typeof exports === 'object')
		exports["declarativeFactory"] = factory();
	else
		root["declarativeFactory"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 